
        import 'DashboardHeader.606fc81.css-module'
        export default {"header":"header_DashboardHeader_606fc81","headerDisabled":"headerDisabled_DashboardHeader_606fc81"}
    